import { render } from "./SendToPartnerPage.vue?vue&type=template&id=48f31b7b&ts=true"
import script from "./SendToPartnerPage.vue?vue&type=script&lang=ts"
export * from "./SendToPartnerPage.vue?vue&type=script&lang=ts"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./SendToPartnerPage.vue?vue&type=style&index=1&id=48f31b7b&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__